<template lang="pug">
  #options
    v-container.pb-0(fluid)
      v-layout#dropdown.dropdown.px-3(row, wrap, justify-center)
        v-flex.options(xs12 sm5 md2)
          p Agresiones reportadas en:
            v-select(
              :items    = "states"
                v-model = "selectState"
              overflow
              label  = "Selecciona"
              target = "#dropdown"
              clearable
              autocomplete
            )
        v-flex.options(xs12 sm5 md3)
          p Buscar palabras en las fichas:
            v-text-field.search.pa-0(append-icon="search"
              v-model = "searchText"
              hide-details
              single-line
              solo
            )
        v-flex.options(xs12 sm5 md2)
          p Ordenar por:
            v-select(
              :items    = "order"
                v-model = "selectOrder"
              overflow
              label  = "Selecciona"
              target = "#dropdown"
              clearable
              autocomplete
            )
        v-flex.options(xs12 sm5 md3)
          p Tipo de incidente:
            v-select(
              :items    = "type"
                v-model = "selectType"
              overflow
              label  = "Selecciona"
              target = "#dropdown"
              clearable
              autocomplete
            )

        v-flex.options(xs12 sm5 md3)
          p Contexto:
            v-select(
            :items="contexts"
            v-model="selectContext"
            overflow
            label="Selecciona"
            target = "#dropdown"
            item-text="context"
            item-value="context"
            clearable
            autocomplete
            )
              //- template(slot="selection" slot-scope="data")
              //-   p {{data.item.context}} - {{data.item.contextId}}
              //- template(slot="item" slot-scope="data")
              //-   v-list-tile-content(v-text="data.item.context")
              //-   p &nbsp;&nbsp;
              //-   v-list-tile-content(v-text="data.item.contextId")
        v-flex.options(xs6 sm4 md2)
          p.p-left Años:
            v-select(
              :items    = "years"
              v-model = "selectMinYear"
              overflow
              label  = "Min"
              target = "#dropdown"
              clearable
              :disabled ='minDisabled'
              autocomplete
            )
        v-flex.options(xs6 sm4 md2)
          p.p-right.transparent .
            v-select(
              :items    = "years"
              v-model = "selectMaxYear"
              overflow
              label  = "Max"
              target = "#dropdown"
              clearable
              :disabled = 'maxDisabled'
              autocomplete
            )
        //- v-flex(xs6 sm4 md3 align-baseline)
        //-   p.transparent .
        //-     v-checkbox.mt-3.check(
        //-       dark
        //-       color='white'
        //-       label=  "Mostrar casos sin año"
        //-       v-model= "showEmptyYear"
        //-     )

        v-flex.options(xs12 sm5 md2)
          p.mb-0 Resultado:
          p.mb-0.content {{reports.length}} CASOS
          //p.mb-0.content 185 CASOS


</template>

<script>
export default {
  name: "Options",
  //props: {},
  data() {
    return {
      years: [],
      minDisabled: false,
      maxDisabled: false,
      type: [
        "Allanamiento",
        "Amenaza",
        "Asesinato",
        "Ataque a bienes materiales",
        "Ataque a redes, comunicaciones digitales y sistemas informáticos",
        "Ataque físico",
        "Bloqueo, alteración o remoción de información",
        "Desaparición",
        "Desplazamiento forzado",
        "Intervención o vigilancia ilegal de comunicaciones.",
        "Intimidación y hostigamiento",
        "Privación de la libertad",
        "Tortura o tratos crueles, inhumanos y degradantes",
        "Uso ilegítimo del poder público"
      ],
      order: ["Estados", "Más reciente", "Más antiguas"],
      states: [
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Chihuahua",
        "Colima",
        "Campeche",
        "Coahuila",
        "Chiapas",
        "Ciudad de México",
        "Durango",
        "Guerrero",
        "Guanajuato",
        "Hidalgo",
        "Jalisco",
        "Estado de México",
        "Michoacán",
        "Morelos",
        "Nayarit",
        "Nuevo León",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "Sinaloa",
        "San Luis Potosí",
        "Sonora",
        "Tabasco",
        "Tlaxcala",
        "Tamaulipas",
        "Veracruz",
        "Yucatán",
        "Zacatecas"
      ]
    };
  },
  computed: {
    reports() {
      return this.$store.state.reports;
    },
    contexts() {
      return this.$store.state.contexts;
    },
    min() {
      return this.$store.state.min;
    },
    max() {
      return this.$store.state.max;
    },
    selectState: {
      get() {
        return this.$store.state.filters.state;
      },
      set(value) {
        this.$store.commit("setStateFilter", value);
        this.update();
      }
    },
    selectMinYear: {
      get() {
        return this.$store.state.filters.minYear;
      },
      set(value) {
        this.$store.commit("setMinYearFilter", value);
        this.update();
        this.maxDisabled = value == "No especificado" ? true : false;
      }
    },
    selectMaxYear: {
      get() {
        return this.$store.state.filters.maxYear;
      },
      set(value) {
        this.$store.commit("setMaxYearFilter", value);
        this.update();
        this.minDisabled = value == "No especificado" ? true : false;
      }
    },
    searchText: {
      get() {
        return this.$store.state.filters.searchText;
      },
      set(value) {
        this.$store.commit("setSearchTextFilter", value);
        this.update();
      }
    },
    selectOrder: {
      get() {
        return this.$store.state.filters.order;
      },
      set(value) {
        this.$store.commit("setOrderFilter", value);
        this.update();
      }
    },
    selectType: {
      get() {
        return this.$store.state.filters.type;
      },
      set(value) {
        this.$store.commit("setTypeFilter", value);
        this.update();
      }
    },
    selectContext: {
      get() {
        return this.$store.state.filters.context;
      },
      set(value) {
        this.$store.commit("setContextFilter", value);
        this.update();
      }
    }
  },
  methods: {
    update: function() {
      this.$store.dispatch("filterReports");
    },
    getContexts() {
      this.$store.dispatch("getContexts");
    },
    createYears() {
      const now = new Date().getUTCFullYear();
      let years = Array(now - 2017)
        .fill("")
        .map((v, idx) => now - idx);
      this.years = [...years, "No especificado"];
    }
  },
  mounted() {
    this.createYears();
  }
};
</script>

<style scoped lang="scss">
@import "../app.scss";

.content {
  font-size: 42px !important;
  color: #c1d542 !important;
  font-family: "Rajdhani", sans-serif;
  font-weight: 600;
  line-height: 50px;
}

.transparent {
  color: transparent !important;
}

.p-left {
  padding-left: 3rem;
}
.p-right {
  padding-right: 3rem;
}

.dropdown {
  //height: 106px;
  @media (max-width: 760px) {
    height: 100%;
  }
  p {
    color: #fff;
    font-size: 1rem;
  }
}
@media (max-width: 760px) {
  .dropdown {
    justify-content: center;
  }
}
@media (max-width: 576px) {
  .dropdown {
    justify-content: center;
  }
  .options {
    height: 6rem !important;
  }
  .p-left {
    padding-left: 0;
  }
  .p-right {
    padding-right: 0;
  }
}
</style>
